import { createRouter, createWebHistory } from "vue-router";
import Main from "../components/Main.vue";
import CsatPage from "../components/CsatPage.vue";
import NewYearPage from "../components/NewYearPage.vue";
import HolidayPage from "../components/HolidayPage.vue";
import { events } from "../data/events";

const routes = [
    { 
        path: "/", 
        name: "main", 
        component: Main,
        meta: {
            title: "쉬운캘린더 | 대한민국 주요 일정 및 공휴일 정보",
            description: "대한민국 주요 일정, 공휴일, 수능 및 모의고사 일정 등을 편리하게 확인해보세요",
            ogTitle: "쉬운캘린더 | 대한민국 주요 일정",
            ogDescription: "대한민국 주요 일정을 편리하게 확인해보세요"
        }
    }, 
    { 
        path: "/csat", 
        name: "csat", 
        component: CsatPage,
        meta: {
            title: "수능/모의고사 일정 | 쉬운캘린더",
            description: "대학수학능력시험 및 모의고사 일정을 확인하세요",
            ogTitle: "수능/모의고사 일정 | 쉬운캘린더",
            ogDescription: "대학수학능력시험 및 모의고사 일정을 확인하세요"
        }
    },
    { 
        path: "/csat/:id", 
        name: "csat-detail", 
        component: CsatPage,
        props: true,
        meta: {}
    },
    { 
        path: "/newyear", 
        name: "newyear", 
        component: NewYearPage,
        meta: {
            title: "새해 디데이 | 쉬운캘린더",
            description: "새해까지 남은 시간, 남은 평일/공휴일을 확인하세요",
            ogTitle: "새해 디데이 | 쉬운캘린더",
            ogDescription: "새해까지 남은 시간, 남은 평일/공휴일을 확인하세요"
        }
    },
    { 
        path: "/holiday", 
        name: "holiday", 
        component: HolidayPage,
        meta: {
            title: "공휴일 및 연휴 정보 | 쉬운캘린더",
            description: "대한민국 공휴일 및 연휴 정보를 한눈에 확인하세요",
            ogTitle: "공휴일 및 연휴 정보 | 쉬운캘린더",
            ogDescription: "대한민국 공휴일 및 연휴 정보를 한눈에 확인하세요"
        }
    },
];

const router = createRouter({ 
    history: createWebHistory(""), 
    routes
}); 

router.beforeEach((to, from, next) => {
    // 동적 타이틀 처리 (csat-detail)
    if (to.name === 'csat-detail' && to.params.id) {
        const eventId = Number(to.params.id);
        const event = events.find(e => e.id === eventId && e.categoryId === 'csat');
        if (event) {
            const date = new Date(event.date);
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            
            let title = "";
            let description = "";
            if (event.title.includes('대학수학능력시험')) {
                // '2026학년도 대학수학능력시험'에서 학년도 추출
                const schoolYearMatch = event.title.match(/\d{4}학년도/);
                const schoolYear = schoolYearMatch ? schoolYearMatch[0] : `${year}학년도`;
                title = `${schoolYear} 수능 일정 / 디데이 | 쉬운캘린더`;
                description = `${schoolYear} 수능 시험 일정, 디데이, 완주율 및 교시별 시간표 정보를 확인하세요.`;
            } else {
                title = `${year}년 ${month}월 모의고사 일정 / 디데이 | 쉬운캘린더`;
                description = `${year}년 ${month}월에 시행되는 ${event.title}의 상세 일정, 디데이 및 시험 시간표 정보를 확인하세요.`;
            }
            
            document.title = title;
            to.meta.title = title;
            to.meta.description = description;
            to.meta.ogTitle = title;
            to.meta.ogDescription = description;
        } else {
            // 이벤트를 찾지 못했을 때 (잘못된 ID 등)
            document.title = "시험 일정 정보 | 쉬운캘린더";
        }
    } else if (to.meta.title) {
        document.title = to.meta.title;
    }

    // Meta Tag 변경 함수
    const setMetaTag = (selector, content) => {
        const element = document.querySelector(selector);
        if (element) {
            element.setAttribute('content', content);
        }
    };

    // Description 변경
    if (to.meta.description) {
        setMetaTag('meta[name="description"]', to.meta.description);
    }

    // OG Title 변경
    if (to.meta.ogTitle) {
        setMetaTag('meta[property="og:title"]', to.meta.ogTitle);
    }

    // OG Description 변경
    if (to.meta.ogDescription) {
        setMetaTag('meta[property="og:description"]', to.meta.ogDescription);
    }

    // Canonical 태그 변경 함수
    const setCanonicalTag = (url) => {
        let canonical = document.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', url);
    };

    // 사이트 기본 도메인
    const baseDomain = "https://calendar.swiun.kr"; 
    setCanonicalTag(`${baseDomain}${to.path}`);

    next();
});

export default router;
